import { Component, OnInit } from '@angular/core';
import { BaseAPIService } from '../Services/api.base.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { IOemDetails } from '../Models/IOemDetails';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';
import { ValidateRulesService } from '../shared/validate-rules.service';
import { UtilService } from '../Services/util.service';
import { IGridCols } from '../Models/IGridCols';


@Component({
  selector: 'app-oem',
  templateUrl: './oem.component.html',
  styleUrls: ['./oem.component.scss'],
  providers: [MessageService]
})
export class OemComponent implements OnInit {
  cols: Array<IGridCols>;
  labels: any;
  messages: any;
  oemDetails: IOemDetails[];
  modalReference: NgbModalRef;
  noData: boolean = false;
  isPagination: boolean = true;
  isLoading: boolean = false;
  showmodal: boolean = false;
  formInvalid: boolean = false;
  newOemDetail: IOemDetails = {
    Id: 0,
    OID: '',
    OEMName: '',
    OEMDesc: '',
    IsActive: 'A'
  };
  public oId: string;
  oemName: string;
  oemDesc: string;
  public targetSearch: string;
  oemIdRequired: string;
  oemNameRequired: string;
  contentHeader: string;
  constructor(private readonly baseService: BaseAPIService, private readonly _validateService: ValidateRulesService, private readonly auth: AuthenticationService, private readonly messageService: MessageService, private readonly translate: TranslateService) { }

  ngOnInit() {
    this.labels = label;
    this.formInvalid = true;
    this.isLoading = true;
    this.messages = message;

    this.cols = [
      { field: 'oid', header: this.labels.oid, width: '7em' },
      { field: 'oemName', header: this.labels.oemName, width: '8em' },
      { field: 'oemDesc', header: this.labels.oemDesc, width: '9em' },
      { field: 'deviceCount', header: this.labels.statDeviceCountTitle, width: '9em' },
    ];

    this.GetOemDetailsList();
  }

  public AddOem() {
    this.formInvalid = true;
    this.showmodal = true;
    this.contentHeader = this.labels.btnAddOem;
    this.ResetOemObject();
  }


  public ResetOemObject() {
    this.oId = '';
    this.oemDesc = '';
    this.oemName = '';
    this.newOemDetail = {
      Id: 0,
      OID: '',
      OEMName: '',
      OEMDesc: '',
      IsActive: 'A'
    };
  }

  public SaveOem(txtOid: any, txtOemName: any) {
    if (this.oId === '') {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidOId), detail: this.translate.instant(this.messages.invalidOId), key: 'error' });
      txtOid.focus();
    } else if (this.oemName === '') {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidOemName), detail: this.translate.instant(this.messages.invalidOemName), key: 'error' });
      txtOemName.focus();
    }
    else {

      this.newOemDetail.OID = this.oId;
      this.newOemDetail.OEMName = this.oemName;
      this.newOemDetail.OEMDesc = this.oemDesc;
      this.isLoading = true;
      this.SaveOrUpdateOemDetails(this.newOemDetail);
    }
  }


  onReject() {
    this.messageService.clear('c');
    this.ResetOemObject();
  }


  public closeModal() {
    this.showmodal = false;
    this.isLoading = false;
    this.ResetOemObject();
  }



  public GetOemDetailsList() {
    this.baseService.GET('/OEM/OEMDetails')
      .subscribe((result: IOemDetails[]) => {
        if (result !== null && result.length > 0) {
          this.oemDetails = result;
          this.isLoading = false;
          if (this.oemDetails.length < 10) {
            this.isPagination = false;
          }
        }
        else {
          this.noData = true;
          this.isPagination = false;
          this.isLoading = false;
        }
      });
  }
  public validate() {
    this.oemIdRequired = this._validateService.requiredElement(this.oId, 'OID', 1, 10);
    this.oemNameRequired = this._validateService.requiredElement(this.oemName, 'Oem Name', 1, 50);
    if (this.oemIdRequired === '' && this.oemNameRequired === '') {
      this.formInvalid = false;
    } else {
      this.formInvalid = true;
    }
  }
  ExportOem() {
    this.isLoading = true;
    this.baseService.DOWNLOAD("/OEM/ExportOemData", null).subscribe((result) => {
      const fileName = `OemDetails_${UtilService.FormatDate(new Date()).toString().replace(' ', '_')}.xlsx`;
      const blob = new Blob([result], { type: "application/octet-stream" });
      saveAs(blob, fileName);
      this.isLoading = false;
    });
  }

  private SaveOrUpdateOemDetails(oem) {
    this.baseService.POST('/OEM/AddOEM', oem).subscribe((result) => {
      this.ResetOemObject();
      if (result === null || result > 0) {
        this.GetOemDetailsList();
        this.showmodal = false;
        this.isLoading = false;
        this.messageService.add({
          severity: 'success', summary: this.translate.instant(this.messages.success), detail: `OEM  ${this.translate.instant(this.messages.ruleAdd)}`, key: 'success'
        });
        return;
      }
      if (result.status === 400) {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.badRequest), detail: this.translate.instant(this.messages.invalidInput), key: 'error' });
      } else {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.errorAdd), key: 'error' });
      }
    }, (error) => {
      this.ResetOemObject();
      this.isLoading = false;
      this.showmodal = false;
      switch (error.error) {
        case this.messages.oemExists:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.badRequest), detail: this.translate.instant(this.messages.oemExists), key: 'error' });
          break;
        case this.messages.oemValuesNotValid:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.badRequest), detail: this.translate.instant(this.messages.oemValuesNotValid), key: 'error' });
          break;
        default:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.errorAdd), key: 'error' });
          break;
      }
    });
  }

}

